var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-bar',{attrs:{"title-stack":_vm.titleStack}}),_c('hero-bar',[_vm._v(" "+_vm._s(_vm.titleHero)+" ")]),_c('section',{staticClass:"section is-main-section"},[_c('customer-reminder')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }